<template>
    <div
      class="card-wrapper"
      v-touch:swipe.left="() => onSwipeLeft(shift, i)"
      v-touch:swipe.right="() => onSwipeRight(shift, i)"
      :class="{
        swipedLeft:
          showActions[i] &&
          (shift.abilities?.delete || shift.abilities?.exit) &&
          shift.status != 13,
      }"
    >
      <div class="job_shift_item1">
        <div class="job_shift_info1">
          <div class="job_shift_text">
            <div class="shift-card-head">
            <div @click="handleClick(shift)" class="job_shift_user1">
              <template v-if="isAgencyFilledShift(shift)">
                <el-avatar
                  :size="30"
                  shape="square"
                  :src="shift.locum?.image"
                  v-if="shift.locum?.image"
                />
                <el-avatar
                  :size="30"
                  class="grid-center gray"
                  shape="square"
                  v-else
                >
                  <UserIcon />
                </el-avatar>
                <div v-if="agencyLocumDisplay(shift)">
                  <strong>
                    Locum: {{ agencyLocumDisplay(shift).firstName }}
                    {{ agencyLocumDisplay(shift).lastName }}
                  </strong>
                </div>
              </template>
              <template v-else-if="shift.locum">
                <el-avatar
                  :size="30"
                  shape="square"
                  :src="shift.locum.image"
                  v-if="shift.locum.image"
                />
                 <el-avatar
                    :size="30"
                    class="grid-center gray"
                    shape="square"
                    v-else
                  >
                   <UserIcon />
                  </el-avatar>
                <div v-if="userRole == 'agency' && agencyLocumDisplay(shift)">
                  <strong>
                    Locum: {{ agencyLocumDisplay(shift).firstName }}
                    {{ agencyLocumDisplay(shift).lastName }}
                  </strong>
                </div>
              </template>
              <template v-else>
                <template
                  v-if="
                    shift.applicationSelected == true &&
                    shift.applicationSelectedBy?.status == 2
                  "
                >
                  <el-avatar
                    :size="30"
                    class="grid-center gray"
                    shape="square"
                  >
                   <UserIcon  />
                  </el-avatar>
                </template>
                <template v-else>
                  <el-avatar
                    :size="30"
                    class="grid-center gray"
                    shape="square"
                  >
                   <UserIcon />
                  </el-avatar>
                </template>
                <div
                  class="locumate-progress"
                  v-if="shift.applicationSelected == false"
                >
                  <div
                    v-if="
                      userRole == 'pharmacy' &&
                      shift.shiftApplicationType != 0
                    "
                  >
                    <ProgressBar
                      :totalSlots="job.maximumApplicationLimit"
                      :filledSlots="shift.totalShiftApplications"
                    />
                  </div>
                </div>
              </template>
            </div>
                <div
                  class="d-flex more-button"
                  v-if="userRole != 'agency' && !isAgencyFilledShift(shift)"
                >
                  <el-button
                    class="text-only icon-button"
                    v-if="shift.locum"
                    @click="goToJobCalendar(shift)"
                  >
                    <CalendarIcon />
                  </el-button>
                  <el-button
                    class="button_more icon-button text-only-black"
                    icon="el-icon-more"
                    v-if="bottomDropUpExist(shift)"
                    @click="emit('update-bottom-drop-up', i, true)"
                  ></el-button>
                  <i
                    class="el-icon-arrow-right"
                    @click="goToJobCalendar(shift)"
                    v-else-if="shift.locum"
                  ></i>
                </div>
            </div>
            <div class="day_info">
              <div class="day_name header">
                <div class="day" v-if="isAustralia">
                  {{
                    $moment(shift.date, "YYYY/MM/DD").format("dddd,")
                  }}
                  {{
                    $moment(shift.date, "YYYY/MM/DD").format(
                      "DD MMM YYYY"
                    )
                  }}
                </div>
                <div class="day" v-else>
                  {{
                    $moment(shift.date, "YYYY/MM/DD").format("dddd,")
                  }}
                  {{
                    $moment(shift.date, "YYYY/MM/DD").format(
                      "MMM DD YYYY"
                    )
                  }}
                </div>
              </div>
            </div>
            <div class="info-wrapper">
              <div class="day_info_block">
                <ClockIcon />
                <div class="day_time data">
                  <span>{{
                    $moment(
                      shift.userStartTime || shift.startTime,
                      "HH:mm"
                    ).format("h:mm A")
                  }}</span>
                  -
                  <span>{{
                    $moment(
                      shift.userEndTime || shift.endTime,
                      "HH:mm"
                    ).format("h:mm A")
                  }}</span
                  >&nbsp;
                  <span v-if="showShiftInformation(shift)">
                    ({{
                      confirmedHours(
                        shift.confirmedHours,
                        shift.startTime,
                        shift.endTime
                      )
                    }})</span
                  >
                  <span v-else>-</span>
                </div>
              </div>
              <div
                class="day_info_block"
                v-if="
                  !isAgencyFilledShift(shift) &&
                  (!shift.shiftBookedAsInternalStaff &&
                    shift.isVisibileAsInternalLocum === false) &&
                  userRole != 'agency'
                "
              >
                <div class="title">
                 <StopwatchIcon color="rgb(var(--locumate-primary-color))" />
                </div>
                <span class="shift-card-label">Break:</span>
                <div class="info">
                  <span v-if="showShiftInformation(shift)">
                    {{
                      shift.userBreakMinutes
                        ? getTimeFromMinutes(shift.userBreakMinutes)
                        : "-"
                    }}</span
                  >
                  <span v-else>-</span>
                </div>
              </div>
              <div
                class="day_info_block"
                v-if="
                  isAgencyFilledShift(shift) ||
                  (!shift.shiftBookedAsInternalStaff &&
                  shift.isVisibileAsInternalLocum === false)
                "
              >
                <div class="title">
                  <DollarWithCircleIcon />
                  <span
                    class="locumate_icons locumate_icon-check shift_confirm"
                    v-if="shift.confirmationDate"
                  ></span>
                </div>
                <span
                  class="shift-card-label"
                  v-if="userRole != 'agency'"
                >Hourly rate:</span>
                <div class="info amount" v-if="userRole == 'agency' || isAgencyFilledShift(shift)">
                  <span>{{ Rate(shift) }}</span>
                </div>
                <div class="info amount" v-else>
                  <span
                    v-if="
                      (showShiftInformation(shift) &&
                        !shift.shiftBookedAsInternalStaff && shift.isVisibileAsInternalLocum === false) ||
                      (showShiftInformation(shift) &&
                        job.openMarketplaceShiftForInternalLocum)
                    "
                    >{{ Rate(shift) }}</span
                  >
                  <span v-else>-</span>
                </div>
              </div>
              <div
                class="day_info_block"
                v-if="
                  !isAgencyFilledShift(shift) &&
                  (!shift.shiftBookedAsInternalStaff &&
                  shift.isVisibileAsInternalLocum === false ) && userRole != 'agency'
                "
              >
                <div class="title">
                 <TravelIcon color="rgb(var(--locumate-primary-color))" />
                </div>
                <span
                  class="shift-card-label"
                  v-if="job.settings.payingForTravel == 3 &&
                    job.maxTravelCompensation !== 0
                  "
                >{{ job.enableTravelAllowanceForFirstAndLastDay === 1 ? "Travel" : "Capped Travel" }}:</span>
                <span class="shift-card-label" v-else>Travel:</span>
                <div class="info">
                  <span v-if="showShiftInformation(shift)">
                    {{ travelCompensationCount(job, shift) }}
                  </span>
                  <span v-else>-</span>
                </div>
              </div>
              <template v-if="isAustralia && userRole != 'agency' && !isAgencyFilledShift(shift)">
                <div
                  class="day_info_block"
                  v-if="
                    !shift.shiftBookedAsInternalStaff &&
                    shift.isVisibileAsInternalLocum === false
                  "
                >
                  <div class="title">
                   <DollarWithCircleIcon />
                  </div>
                  <span class="shift-card-label">Total Super:</span>
                  <div class="info amount">
                    <span
                      v-if="
                        (showShiftInformation(shift) &&
                          !shift.shiftBookedAsInternalStaff && shift.isVisibileAsInternalLocum === false) ||
                        (showShiftInformation(shift) &&
                          job.openMarketplaceShiftForInternalLocum)
                      "
                    >
                      {{ totalSuperRate(shift) }}</span
                    >
                    <span v-else>-</span>
                  </div>
                </div>
              </template>
              <div
                class="day_info_block"
                v-if="
                  !isAgencyFilledShift(shift) &&
                  (!shift.shiftBookedAsInternalStaff &&
                  shift.isVisibileAsInternalLocum === false) &&
                  userRole != 'agency'
                "
              >
                <div class="title">
                    <DollarWithCircleIcon />
                </div>
                <span class="shift-card-label">Total shift sum:</span>
                <div class="info amount">
                  <span
                    v-if="
                      (showShiftInformation(shift) &&
                        !shift.shiftBookedAsInternalStaff && shift.isVisibileAsInternalLocum === false) ||
                      (showShiftInformation(shift) &&
                        job.openMarketplaceShiftForInternalLocum)
                    "
                  >
                    {{ Sum(shift) }}</span
                  >
                  <span v-else>-</span>
                </div>
              </div>
            </div>
          </div>
          <div class="job_shift_text" v-if="isBlockShift === 0">
            <div
              class="job_application_wrapper"
              v-if="
                userRole == 'pharmacy' &&
                shift.shiftApplicationType !== 0 &&
                shift.locum == null &&
                !isAgencyFilledShift(shift)
              "
            >
              <el-collapse
                accordion
                :model-value="activeCollapse"
                @update:model-value="emit('update-active-collapse', $event)"
                v-if="shift.shiftApplications?.length > 0"
              >
                <el-collapse-item
                  class="card-accordeon"
                  :title="`${shift.shiftApplications.length} Shift applicant${shift.shiftApplications.length > 1 ? 's' : ''}`"
                  :name="shift.id"
                >
                  <div
                    v-for="applicant in shift.shiftApplications"
                    :key="applicant.id"
                  >
                    <div class="collapse-list applicant-list">
                      <div class="collapse-item">
                        <div class="avatar-row avatar-row--col">
                          <div class="avatar-row-left">
                            <template v-if="applicant.locum">
                              <el-avatar
                                :size="'small'"
                                shape="square"
                                :src="applicant.locum.image"
                                v-if="applicant.locum.image"
                              />
                            <el-avatar :size="50" shape="square" class="grid-center gray" v-else>
                              <UserIcon :width="32" :height="32" :viewBox="'0 0 16 16'"/>
                            </el-avatar>
                            </template>
                            <p>
                              <span>{{ applicant.locum.name }}</span>
                              <span
                                class="text-secondary"
                                style="font-size: 12px"
                              >
                                Locum rate:
                                <span class="rate">{{
                                  formatCurrency(applicant.locumRate)
                                }}</span>
                              </span>
                            </p>
                            <div
                              v-if="
                                shift.applicationSelectedBy?.status == 2
                              "
                              class="ml-auto"
                            >
                              <el-tag
                                class="confirmation-status"
                                v-if="
                                  shift.applicationSelectedBy?.id ==
                                    applicant.id
                                "
                              >
                                Pending Confirmation
                              </el-tag>
                            </div>
                            <div
                              v-else
                              class="day_info_block_btn ml-auto"
                            >
                              <el-checkbox
                                class="c-label"
                                :checked="isSelected(applicant.id)"
                                @change="
                                  handleCheckboxChange(applicant.id)
                                "
                              ></el-checkbox>
                            </div>
                          </div>
                        </div>
                      </div>
                    </div>
                  </div>
                </el-collapse-item>
              </el-collapse>
            </div>
          </div>
        </div>
        <el-drawer
          custom-class="bottom_drop_up"
          :model-value="bottomDropUp[i]"
          @update:model-value="(val) => emit('update-bottom-drop-up', i, val)"
          :append-to-body="true"
          :with-header="false"
          :direction="'btt'"
          :destroy-on-close="true"
        >
          <el-button
            type="transparent"
            class="menu_item mt-0"
            v-if="userRole == 'pharmacy' && shift.abilities?.update"
            @click="actions.editShift(job, shift, i)"
          >
            <EditOutlineIcon color="rgb(var(--locumate-clr-text))" :width="20" :height="20" />
            <span>Edit shift</span>
          </el-button>
          <el-button
            type="transparent"
            class="menu_item mt-0"
            v-if="
              userRole == 'pharmacy' &&
              shift.applicationSelected == false &&
              shift.shiftApplicationType !== 0 &&
              shift.locum == null
            "
            @click="actions.viewApplicants(job, shift, i)"
          >
            <EyeIcon color="rgb(var(--locumate-clr-text))" />
            <span>View Applicants</span>
          </el-button>
          <el-button
            type="transparent"
            class="menu_item mt-0"
            v-if="
              userRole == 'pharmacy' &&
              shift.applicationSelected == true &&
              !shift.userId
            "
            @click="actions.removeApplicants(job, shift, i)"
          >
            <UserRemoveIcon />  
            <span>Withdraw Applicant</span>
          </el-button>
          <el-button
            type="transparent"
            class="menu_item mt-0"
            @click="goToJobApplicants(shift.id)"
            v-if="
              !shift.userId &&
              shift.shiftApplicationType !== 0 &&
              userRole === 'pharmacy'
            "
          >
            <UsersIcon color="rgb(var(--locumate-clr-text))" :width="20" :height="20" />
            <span>All Applicants</span>
          </el-button>
          <el-button
            type="transparent"
            class="menu_item red mt-0"
            v-if="
              userRole === 'pharmacy' &&
              (shift.abilities?.delete || shift.abilities?.exit) &&
              shift.status != 13
            "
            @click="isBlockShift === 1 ? actions.bulkViewShifts(job, shift, i) : actions.openDialog(job, shift, i)"
          >
            <TrashOutlineIcon :width="20" :height="20" />
            
            <span>Remove Shift</span>
          </el-button>
          <el-button
            type="transparent"
            class="menu_item red mt-0"
            v-if="
              userRole === 'locum' &&
              (shift.abilities?.delete || shift.abilities?.exit) &&
              shift.status != 13
            "
            @click="isBlockShift === 1 ? actions.bulkViewShifts(job, shift, i) : actions.openDialog(job, shift, i)"
          >
            <TrashOutlineIcon :width="20" :height="20" />
            <span>Remove Shift</span>
          </el-button>
          <el-button
            type="transparent"
            class="menu_item red"
            v-if="userRole === 'pharmacy' && shift.status == 13"
            @click="actions.goToGuestShiftDetails(shift, i)"
            ><span
              class="locumate_icons locumate_icon-remove_square"
            ></span>
            <span>It's a Guest Shift</span>
          </el-button>
          <div
            v-else-if="
              !(shift.abilities?.delete || shift.abilities?.exit)
            "
            type="transparent"
            class="menu_item_reminder"
          >
            Please call {{ $filters.appName() }} on
            {{ $filters.appContactNumber() }} or email
            {{ $filters.appSupportEmail() }} to cancel this shift. A
            cancellation fee is applicable for shifts cancelled within
            72 hours of start time.
          </div>
        </el-drawer>
      </div>
      <div class="actions" v-show="showActions[i]">
        <button
          class="delete-btn"
          v-show="showActions[i]"
          v-if="
            userRole === 'pharmacy' &&
            (shift.abilities?.delete || shift.abilities?.exit) &&
            shift.status != 13
          "
          @click.prevent="isBlockShift === 1 ? actions.bulkViewShifts(job, shift, i) : actions.openDialog(job, shift, i)"
        >
          <TrashIcon :color="'white'" :width="24" :height="24" />
        </button>
  
        <button
          class="delete-btn"
          v-show="showActions[i]"
          v-if="
            userRole === 'locum' &&
            (shift.abilities?.delete || shift.abilities?.exit) &&
            shift.status != 13
          "
          @click.prevent="isBlockShift === 1 ? actions.bulkViewShifts(job, shift, i) : actions.openDialog(job, shift, i)"
        >
          <TrashIcon :color="'white'" :width="24" :height="24" />
        </button>
      </div>
    </div>
  </template>
  
  <script setup>
  import { inject, getCurrentInstance, computed } from "vue";
  import { useStore } from "vuex";
  import moment from "moment";
  import ProgressBar from "../Days/ProgressBar.vue";
  import timeDiff from "@/helpers/date/timeDiff";
  import timeDiffAsDecimal from "@/helpers/date/timeDiffAsDecimal";
  import { locumCanSeeShiftRates } from "@/helpers/utility/locumShiftRates";
  import { 
    CalendarIcon, 
    ClockIcon, 
    DollarWithCircleIcon, 
    TravelIcon, 
    StopwatchIcon, 
    UserIcon, 
    EditOutlineIcon, 
    TrashOutlineIcon, 
    EyeIcon, 
    UsersIcon,
    UserRemoveIcon,
    TrashIcon,
  } from "@/components/Icons";
  
  // eslint-disable-next-line no-undef
  const props = defineProps({
    shift: {
      type: Object,
      required: true,
    },
    i: {
      type: Number,
      required: true,
    },
    job: {
      type: Object,
      required: true,
    },
    userRole: {
      type: String,
      required: true,
    },
    isBlockShift: {
      type: Number,
      required: true,
    },
    isAustralia: {
      type: Boolean,
      required: true,
    },
    showActions: {
      type: Array,
      required: true,
    },
    bottomDropUp: {
      type: Array,
      required: true,
    },
    activeCollapse: {
      type: String,
      default: "",
    },
    // Methods/functions that need parent state
    handleClick: {
      type: Function,
      required: true,
    },
    goToJobCalendar: {
      type: Function,
      required: true,
    },

    formatCurrency: {
      type: Function,
      required: true,
    },
    isSelected: {
      type: Function,
      required: true,
    },
    handleCheckboxChange: {
      type: Function,
      required: true,
    },
    goToJobApplicants: {
      type: Function,
      required: true,
    },
    actions: {
      type: Object,
      required: true,
    },
  });
    // eslint-disable-next-line no-undef
  const emit = defineEmits(['update-bottom-drop-up', 'update-active-collapse', 'update-show-actions']);
  
  const instance = getCurrentInstance();
  const $moment = inject("$moment");
  const $filters = instance?.appContext?.config?.globalProperties?.$filters || {};
  const $store = useStore();
  
  const userData = computed(() => $store.getters.GET_USER_DATA);
  
  // Functions moved from Details.vue - only used in ShiftCard
  const onSwipeLeft = (application, index) => {
    emit('update-show-actions', index, true);
  };
  
  const onSwipeRight = (application, index) => {
    emit('update-show-actions', index, false);
  };
  
  const bottomDropUpExist = () => {
    return true;
  };
  
  const confirmedHours = (confirmedHours, startTime, endTime) => {
    let result;
    if (confirmedHours == 0) {
      const start = moment(startTime, "HH:mm:ss");
      const end = moment(endTime, "HH:mm:ss");
      result = timeDiff(start, end);
    } else {
      const string = String(confirmedHours);
      const hours = string.split(".")[0];
      let minutes = string.split(".")[1];
      if (!minutes) {
        const time = hours + ":" + "00";
        result = String(time);
      } else {
        minutes = Number.parseFloat(`0.${minutes}`) * 60;
        result = hours + ":" + minutes.toFixed(0);
      }
    }
    return formatDurationDisplay(result);
  };

  const formatDurationDisplay = (value) => {
    const raw = value === null || value === undefined ? "" : String(value);
    let hours = 0;
    let minutes = 0;

    if (raw.includes(":")) {
      const [hourPart, minutePart] = raw.split(":");
      hours = parseInt(hourPart, 10) || 0;
      minutes = parseInt(minutePart, 10) || 0;
    } else if (raw.includes(".")) {
      const [hourPart, minutePart] = raw.split(".");
      hours = parseInt(hourPart, 10) || 0;
      minutes = parseInt(minutePart, 10) || 0;
    } else {
      hours = parseInt(raw, 10) || 0;
    }

    if (hours > 0 && minutes > 0) {
      return `${hours}h ${minutes}m`;
    }
    if (hours > 0) {
      return `${hours}h`;
    }
    return `${minutes} m`;
  };
  
  const getTimeFromMinutes = (mins) => {
    if (mins >= 24 * 60 || mins < 0) {
      throw new RangeError(
        "Valid input should be greater than or equal to 0 and less than 1440."
      );
    }
    const hours = (mins / 60) | 0;
    const minutes = mins % 60 | 0;

    if (hours > 0 && minutes > 0) {
      return `${hours}h ${minutes}m`;
    }
    if (hours > 0) {
      return `${hours}h`;
    }
    return `${minutes} m`;
  };
  
  const showShiftInformation = (shift) => {
    if (props.userRole === "pharmacy") return true;
    if (
      shift?.job?.isInternalStaffOfThisPharmacy &&
      shift.shiftSubscription
    ) {
      return false;
    }
    if (!shift.userId) return true;
    if (shift.userId === userData.value.id) return true;
    return false;
  };

  const isAgencyFilledShift = (shift) => shift?.status === 14;

  const agencyLocumDisplay = (shift) => {
    const locum = shift?.shiftAgencyLocum || shift?.agency?.locum;
    if (!locum) return null;
    const firstName = locum.firstName ?? locum.first_name ?? "";
    const lastName = locum.lastName ?? locum.last_name ?? "";
    const rateIncSuper = locum.rateIncSuper ?? locum.rate_inc_super ?? null;
    return { firstName, lastName, rate: locum.rate, rateIncSuper };
  };
  
  const Rate = (shift) => {
    // Agency-filled: rate from shiftAgencyLocum (matches Days.vue agency card)
    if (isAgencyFilledShift(shift) || props.userRole == "agency") {
      const agencyLocum = agencyLocumDisplay(shift);
      return agencyLocum?.rate != null
        ? new Intl.NumberFormat("en-AU", {
            style: "currency",
            currency: "AUD",
          }).format(agencyLocum.rate)
        : "-";
    }
    if (props.userRole === "pharmacy") {
      return shift.payRateExecSuper
        ? new Intl.NumberFormat("en-AU", {
            style: "currency",
            currency: "AUD",
          }).format(shift.payRateExecSuper)
        : "-";
    } else {
      if (shift.locum == null && shift.payRateExecSuper == null) {
        return Intl.NumberFormat("en-AU", {
          style: "currency",
          currency: "AUD",
        }).format(shift.recommendedRate);
      } else {
        return Intl.NumberFormat("en-AU", {
          style: "currency",
          currency: "AUD",
        }).format(shift.payRateExecSuper);
      }
    }
  };
  
  const confirmedHoursValue = (shift) => {
    if (shift.confirmedHours == 0 || shift.confirmedHours == null) {
      const start = moment(shift.startTime, "HH:mm:ss");
      const end = moment(shift.endTime, "HH:mm:ss");
      return timeDiffAsDecimal(start, end);
    }
    return shift.confirmedHours;
  };

  const formatAud = (amount) =>
    Intl.NumberFormat("en-AU", {
      style: "currency",
      currency: "AUD",
    }).format(amount);

  const totalSuperRate = (shift) => {
    if (!locumCanSeeShiftRates(shift, props.userRole)) {
      return "-";
    }
    const confirmedHoursVal = confirmedHoursValue(shift);

    // Agency-filled shifts have no locum pay_rate_super. Super is the gap
    // between the agency locum rate and the rate including super.
    if (isAgencyFilledShift(shift)) {
      const agencyLocum = agencyLocumDisplay(shift);
      const rate = Number(agencyLocum?.rate);
      const rateIncSuper = Number(agencyLocum?.rateIncSuper);
      if (!Number.isFinite(rate) || !Number.isFinite(rateIncSuper)) {
        return "-";
      }
      const superRate = (rateIncSuper - rate) * confirmedHoursVal;
      return superRate ? formatAud(superRate) : "-";
    }

    const superRate = shift.payRateSuper * confirmedHoursVal;

    return superRate ? formatAud(superRate) : "-";
  };
  
  const listedShiftsCount = (job) => {
    if (Array.isArray(job?.shifts) && job.shifts.length > 0) {
      return job.shifts.length;
    }
    return 0;
  };

  const normalizeShiftDate = (value) => {
    if (!value) return null;
    const parsed = moment(
      value,
      ["YYYY/MM/DD", "YYYY-MM-DD", "DD/MM/YYYY", moment.ISO_8601],
      true
    );
    return parsed.isValid() ? parsed.format("YYYY-MM-DD") : null;
  };

  const isFirstOrLastBulkShift = (job, shift, index) => {
    const shiftsLength = listedShiftsCount(job);
    if (shiftsLength > 1) {
      return {
        isBoundary: index === 0 || index === shiftsLength - 1,
        hasBulkSpan: true,
      };
    }

    const shiftDate = normalizeShiftDate(shift?.date);
    const startDate = normalizeShiftDate(job?.startDate);
    const endDate = normalizeShiftDate(job?.endDate);
    if (shiftDate && startDate && endDate && startDate !== endDate) {
      return {
        isBoundary: shiftDate === startDate || shiftDate === endDate,
        hasBulkSpan: true,
      };
    }

    return { isBoundary: true, hasBulkSpan: false };
  };

  const applyFirstLastTravelSplit = (job, shift, index, travelAmount) => {
    if (
      job?.isBlockShift != 1 ||
      job?.enableTravelAllowanceForFirstAndLastDay != 1 ||
      shift?.adminUpdatedTravelCompensation === true
    ) {
      return travelAmount;
    }

    const { isBoundary, hasBulkSpan } = isFirstOrLastBulkShift(job, shift, index);
    if (!hasBulkSpan) {
      return travelAmount;
    }
    if (isBoundary) {
      return Number(travelAmount || 0) / 2;
    }
    return 0;
  };

  const resolveFullTravelAmount = (job, shift) => {
    const globalTravelCompensationValue =
      process.env.VUE_APP_TRAVEL_COMPENSATION;

    if (shift.adminUpdatedTravelCompensation === true) {
      if (
        !shift.shiftBookedAsInternalStaff ||
        shift.isVisibileAsInternalLocum === false
      ) {
        return Number(shift.travelCompensation || 0);
      }
      return 0;
    }

    if (
      shift.travelCompensation != null &&
      shift.travelCompensation !== "" &&
      Number(shift.travelCompensation) > 0
    ) {
      return Number(shift.travelCompensation);
    }

    let jobDistance = shift.distance ? shift.distance : null;
    if (jobDistance === null && job?.distance) {
      jobDistance = job.distance;
    }
    if (!jobDistance || !job?.settings?.payingForTravel) {
      return 0;
    }

    const distance = jobDistance;
    if (job.settings.payingForTravel == 1) {
      return distance * 2 > 50
        ? (distance * 2 - 50) * globalTravelCompensationValue
        : 0;
    }
    if (job.settings.payingForTravel == 2) {
      return distance * 2 * globalTravelCompensationValue;
    }
    if (
      job.settings.payingForTravel === 3 &&
      job.maxTravelCompensation !== 0
    ) {
      const realTravelCost = distance * 2 * globalTravelCompensationValue;
      return realTravelCost > job.maxTravelCompensation
        ? job.maxTravelCompensation
        : realTravelCost;
    }
    return 0;
  };

  const Sum = (shift) => {
    if (!locumCanSeeShiftRates(shift, props.userRole)) {
      return "-";
    }

    let Sum;
    let confirmedHoursVal;
    let payRate;
    if (props.userRole === "locum") {
      if (shift.locum == null && shift.payRateExecSuper == null) {
        payRate = shift.recommendedRate;
      } else {
        payRate = shift.payRateExecSuper;
      }
    } else {
      payRate = shift.payRateExecSuper;
    }
    if (shift.confirmedHours == 0 || shift.confirmedHours == null) {
      const start = moment(shift.startTime, "HH:mm:ss");
      const end = moment(shift.endTime, "HH:mm:ss");
      confirmedHoursVal = timeDiffAsDecimal(start, end);
    } else {
      confirmedHoursVal = shift.confirmedHours;
    }

    let travelCompensation = resolveFullTravelAmount(props.job, shift);
    if (shift.adminUpdatedTravelCompensation !== true) {
      travelCompensation = applyFirstLastTravelSplit(
        props.job,
        shift,
        props.i,
        travelCompensation
      );
    }

    if (payRate != null) {
      Sum = payRate * confirmedHoursVal + travelCompensation;
    } else {
      Sum = 0;
    }

    if (Sum != 0) {
      Sum = new Intl.NumberFormat("en-AU", {
        style: "currency",
        currency: "AUD",
      }).format(Sum);
    } else {
      Sum = "-";
    }

    return Sum;
  };

  const travelCompensationCount = (job, shift) => {
        if (shift.adminUpdatedTravelCompensation === true) {
          const presetAmount = Number(shift.travelCompensation || 0);
          if (presetAmount === 0) {
            return "-";
          }
          return new Intl.NumberFormat("en-AU", {
            style: "currency",
            currency: "AUD",
          }).format(presetAmount);
        }

        if (
          shift.status === 0 &&
          props.userRole === 'pharmacy' &&
          job.settings?.payingForTravel == 3 &&
          job.maxTravelCompensation !== 0 &&
          (shift.travelCompensation == null ||
            shift.travelCompensation === "" ||
            Number(shift.travelCompensation) === 0)
        ) {
          let travelAmount = job.maxTravelCompensation;
          if (job.isBlockShift == 1 && job.enableTravelAllowanceForFirstAndLastDay == 1) {
            const { isBoundary, hasBulkSpan } = isFirstOrLastBulkShift(
              job,
              shift,
              props.i
            );
            if (hasBulkSpan) {
              travelAmount = isBoundary ? Number(travelAmount || 0) / 2 : 0;
            }
          }
          if (Number(travelAmount) === 0) {
            return "-";
          }
          return new Intl.NumberFormat("en-AU", {
              style: "currency",
              currency: "AUD",
            }).format(travelAmount);
        }

        let fullAmount = resolveFullTravelAmount(job, shift);
        fullAmount = applyFirstLastTravelSplit(job, shift, props.i, fullAmount);

        if (!fullAmount) {
          return "-";
        }

        return new Intl.NumberFormat("en-AU", {
          style: "currency",
          currency: "AUD",
        }).format(fullAmount);
      };
  </script>

  <style scoped lang="scss">
  .job_shift_item1 {
    border: 1px solid rgb(var(--locumate-clr-gray-light));
    border-radius: var(--locumate-corner-radius, 8px);
    padding: 16px;
    margin-bottom: 16px;
    background: #fff;
  }

  .shift-card-head {
    display: flex;
    align-items: flex-start;
    justify-content: space-between;
    gap: 12px;
  }

  .job_shift_user1 {
    display: flex;
    align-items: center;
    gap: 8px;
    min-width: 32px;
    margin: 0;

    :deep(.el-avatar) {
      flex: 0 0 32px;
      width: 32px;
      height: 32px;
      border-radius: 6px;
      background: #e8eaee;
    }
  }

  .more-button {
    position: static;
    align-items: center;
    gap: 4px;

    :deep(.icon-button) {
      margin: 0;
      padding: 4px;
    }

    :deep(.button_more.icon-button) {
      --btn-color: rgb(var(--locumate-clr-text));
      --btn-hover-color: rgb(var(--locumate-clr-text));
      color: rgb(var(--locumate-clr-text));
    }

    :deep(.el-icon-more) {
      transform: rotate(90deg);
    }
  }

  .day {
    margin-top: 12px;
    font-size: 18px;
    font-weight: 700;
    line-height: 1.3;
    color: #1b2a4e;
  }

  .info-wrapper {
    display: flex;
    flex-direction: column;
    gap: 10px;
    margin-top: 14px;
  }

  .day_info_block {
    display: grid;
    grid-template-columns: 20px minmax(120px, 46%) 1fr;
    align-items: center;
    column-gap: 8px;
    min-width: 0;
    font-size: 15px;
    color: #1b2a4e;

    &:has(.day_time) {
      grid-template-columns: 20px 1fr;
    }

    > :deep(svg),
    > .title {
      width: 20px;
      height: 20px;
      display: flex;
      align-items: center;
      justify-content: center;
    }
  }

  .shift-card-label,
  .info,
  .data {
    font-size: 15px;
    font-weight: 500;
    color: #1b2a4e;
  }

  .title {
    position: relative;

    .shift_confirm {
      position: absolute;
      right: -4px;
      bottom: -3px;
      display: flex;
      align-items: center;
      justify-content: center;
      width: 14px;
      height: 14px;
      margin: 0;
      padding: 0;
      border: 2px solid #fff;
      border-radius: 50%;
      background: #12b76a;
      box-shadow: 0 0 0 1px rgba(18, 183, 106, 0.25);
      font-size: 0;
      line-height: 0;
      z-index: 1;

      &::before {
        content: "";
        width: 3px;
        height: 6px;
        margin-top: -1px;
        border: solid #fff;
        border-width: 0 1.5px 1.5px 0;
        transform: rotate(45deg);
      }
    }
  }
  </style>
  
